import { render, staticRenderFns } from "./BtnCancelarContrato.vue?vue&type=template&id=75e6b4ee&"
import script from "./BtnCancelarContrato.vue?vue&type=script&lang=js&"
export * from "./BtnCancelarContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports